import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { GraduationCap, BookOpen, School, ArrowRight } from "lucide-react";

const OPTIONS = [
  { code: "JUPEB", to: "/jupeb", icon: GraduationCap, desc: "Advanced-level pathway to eligible Direct Entry into 200 Level." },
  { code: "IJMB", to: "/ijmb", icon: BookOpen, desc: "Alternative advanced-level pathway toward Direct Entry opportunities." },
  { code: "Remedial", to: "/remedial", icon: School, desc: "Foundation programme preparing you for JAMB and admission into IAUE." },
];

export function ProgrammeChooser() {
  return (
    <section
      className="relative py-10 sm:py-14"
      style={{ background: "linear-gradient(135deg,#FFFFFF 0%, #EAF2FD 55%, #CFE0F7 100%)" }}
      data-testid="programme-chooser"
    >
      <div className="container-x">
        <p className="text-center text-2xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-[0.12em] text-[#0A1E4E]">Choose Your Programme</p>
        <div className="mt-7 grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
          {OPTIONS.map((o, i) => (
            <motion.div key={o.code} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.08 }}>
              <Link
                to={o.to}
                data-testid={`chooser-${o.code.toLowerCase()}`}
                className="group flex h-full flex-col rounded-sm border border-[#0A1E4E]/15 bg-white p-6 shadow-sm transition-all hover:-translate-y-1 hover:border-[#0A1E4E] hover:shadow-xl"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-sm text-[#0A1E4E] shadow-[0_6px_20px_-4px_rgba(215,255,0,0.9)]" style={{ background: "#DDFF00" }}>
                  <o.icon size={24} />
                </div>
                <h3 className="mt-4 font-serif text-2xl font-bold text-[#0A1E4E]">{o.code}</h3>
                <p className="mt-2 flex-1 text-sm text-slate-600 leading-relaxed">{o.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 rounded-sm px-3 py-1.5 text-sm font-extrabold text-[#0A1E4E] transition-all group-hover:gap-2.5" style={{ background: "#DDFF00" }}>
                  Explore {o.code} <ArrowRight size={15} />
                </span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
